export const filterOptions = (options = [], searchFilter = '') => !searchFilter.length
  ? options
  : options.filter(({ label }) => label.toLowerCase().startsWith(searchFilter.toLocaleLowerCase()))
